module.exports = __webpack_public_path__ + "img/12227_27.6b30be98.png";